import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgNieuwsDocument = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <g clipPath="url(#Nieuws-Document_svg__a)">
      <mask
        id="Nieuws-Document_svg__b"
        width={33}
        height={36}
        x={3}
        y={2}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          d="m3.89 6.88 11.59-3.11 5.8-1.55 7.34 4.24 2.59 9.66 4.14 15.45-23.18 6.21z"
        />
      </mask>
      <g mask="url(#Nieuws-Document_svg__b)">
        <path
          fill="#FED27A"
          d="M15.23 28 2.98 20.92l7.07-12.24z"
        />
        <path
          fill="#F7A941"
          d="m-4.09 33.17 7.07-12.25L15.23 28zM10.05 8.68 2.98 20.92l-12.24-7.07z"
        />
        <path
          fill="#FED27A"
          d="M34.55 22.82 22.3 15.75 29.37 3.5zM10.05 8.68l12.25 7.07L15.23 28z"
        />
        <path
          fill="#FED27A"
          d="m15.23 28 7.07-12.25 12.25 7.07zM29.37 3.5 22.3 15.75 10.05 8.68z"
        />
        <path
          fill="#F7A941"
          d="m15.23 28 12.25 7.07-7.07 12.24z"
        />
        <path
          fill="#F7A941"
          d="m39.73 42.14-12.25-7.07 7.07-12.25z"
        />
        <path
          fill="#F7A941"
          d="m34.55 22.82-7.07 12.25L15.23 28zM20.41 47.31l7.07-12.24 12.25 7.07zM-4.09 33.17l12.25 7.07-7.07 12.25z"
        />
        <path
          fill="#FED27A"
          d="M20.41 47.31 8.16 40.24 15.23 28z"
        />
        <path
          fill="#FED27A"
          d="M15.23 28 8.16 40.24l-12.25-7.07zM4.88-10.64l12.25 7.07-7.08 12.25zM29.37 3.5 17.13-3.57l7.07-12.25z"
        />
        <path
          fill="#FED27A"
          d="m10.05 8.68 7.08-12.25L29.37 3.5zM10.05 8.68-2.19 1.6l7.07-12.24z"
        />
        <path
          fill="#FED27A"
          d="M-9.26 13.85-2.19 1.6l12.24 7.08z"
        />
        <path
          fill="#F7A941"
          d="m29.37 3.5 12.25 7.07-7.07 12.25z"
        />
        <path
          fill="#FED27A"
          d="m34.55 22.82 7.07-12.25 12.25 7.07zM48.69-1.68l-7.07 12.25L29.37 3.5zM34.55 22.82l12.25 7.07-7.07 12.25z"
        />
        <path
          fill="#FED27A"
          d="M53.87 17.64 46.8 29.89l-12.25-7.07zM24.2-15.82l12.25 7.07L29.37 3.5z"
        />
        <path
          fill="#F7A941"
          d="m29.37 3.5 7.08-12.25 12.24 7.07z"
        />
      </g>
      <path
        fill="#F18700"
        fillRule="evenodd"
        d="m28.62 6.46-5.79 1.55-1.55-5.79z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        d="m8.47 12.38-.26-.97 9.66-2.59.26.97zM10.02 18.17l-.26-.96 17.39-4.66.26.96zM11.32 23l-.26-.96 17.38-4.66.26.96z"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M15.19 29.73 21 28.18A2 2 0 0 1 22 32l-5.8 1.55a2 2 0 1 1-1-3.86z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="Nieuws-Document_svg__a">
        <path
          fill="#fff"
          d="M0 0h40v40H0z"
        />
      </clipPath>
    </defs>
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgNieuwsDocument);

export default ForwardRef;
